import React from 'react';
import { PlanIsporukaInPlanerTab } from './goldCmPlannerPanel';

type Locale = 'hr' | 'en';

/**
 * Modul 40.41 — Plan & generate (stari): owner-only referenca dok novi wizard 40.4 ne dosegne paritet.
 * PHASED algoritam: sve narudžbe → plan isporuke + plan preskladištenja + prijedlog narudžbe.
 *
 * Naslov je do 26.08.2026. pisao "40.4", broj koji je u međuvremenu preuzeo novi wizard
 * (biModuleRegistry.ts: 40.4 = warehouse_plan_wizard, 40.41 = warehouse_plan_generate).
 * Zbog toga je ekran otvoren iz kartice 40.41 u zaglavlju tvrdio da je 40.4.
 */
export function WarehousePlanGenerateModule({ locale, token, onBack }: { locale: Locale; token: string | null; onBack?: () => void }) {
    const t = (hr: string, en: string) => (locale === 'en' ? en : hr);

    return (
        <section className="card admin-block">
            {onBack ? <button type="button" className="secondary compact" onClick={onBack} style={{ marginBottom: 8 }}>← {t('Natrag na Skladišno', 'Back to Warehouse')}</button> : null}
            <div className="bi-module-hero">
                <div className="bi-module-hero-icon">🚚</div>
                <div className="bi-module-hero-text">
                    <h1>40.41 · {t('Plan & generate (stari)', 'Plan & generate (legacy)')}</h1>
                    <p className="muted">{t('Planiranje i generiranje isporuka, preskladištenja i prijedloga narudžbe (PHASED algoritam).', 'Planning and generation of deliveries, restocking and order proposals (PHASED algorithm).')}</p>
                </div>
            </div>
            <PlanIsporukaInPlanerTab token={token ?? ''} locale={locale} />
        </section>
    );
}
